var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Email_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0H0v16h16z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Email_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.55 5.044a3.117 3.117 0 0 0-3.116-3.116H3.567A3.117 3.117 0 0 0 .45 5.044v.695a1 1 0 0 0 0 .089v5.128a3.117 3.117 0 0 0 3.117 3.116h8.867a3.117 3.117 0 0 0 3.116-3.116V5.828a1 1 0 0 0 0-.09zM8 7.1q3.177 0 5.75-1.777v-.279c0-.727-.59-1.316-1.316-1.316H3.567c-.727 0-1.317.59-1.317 1.316v.28Q4.824 7.1 8 7.1m-5.75 3.856V7.434q.906.495 1.894.832Q6.011 8.9 8 8.9a11.9 11.9 0 0 0 5.75-1.466v3.522c0 .727-.59 1.316-1.316 1.316H3.567c-.727 0-1.317-.59-1.317-1.316",
    clipRule: "evenodd"
  }))));
};
export default SvgEmail;